
import { ref, defineComponent } from 'vue';
import { useRoute } from 'vue-router'

/* Stores */
import { useAppStore } from '@/store/app'

/* 组件 */
import { useWatermark } from '@/hooks/useWatermark'
import { DocumentEditor, IConfig } from "@onlyoffice/document-editor-vue"

/* Apis */
import { GetDocConfigApi } from '@/apis/attachment/attachment.api'

export default defineComponent({
    components: { DocumentEditor },
    async setup() {

        const login = useAppStore().getLoginInfo
        const { setWatermark } = useWatermark()

        const { query } = useRoute()

        const configData = await GetDocConfigApi(query.fileId as string, "view")
        const docJsFile = ref<string>('https://office.voion.com/ds-vpath/')
        const editConfig = ref<IConfig | any>(configData.data)

        const methods: {
            onAppReady: () => void
            requestHistory: (event: any, pr: any) => void
            requestHistoryData: (event: any, pr: any) => void
        } = {

            onAppReady: () => {
                setWatermark(`${login.user_name}(${login.user_account})`)
            },

            requestHistory: (event: any, pr: any) => {
            },

            requestHistoryData: (event: any, pr: any) => {
            }
        }


        return { docJsFile, editConfig, methods }
    },
})

